import { Link, MessageCircle, Share2 } from 'lucide-react';
import { toast } from 'sonner';

interface Props {
  url: string;
  title: string;
  className?: string;
}

const baseBtn: React.CSSProperties = {
  minHeight: 44,
  borderRadius: 8,
  padding: '8px 14px',
  fontSize: 12,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  fontWeight: 500,
  transition: 'all 0.15s',
};

export function EbookShareButtons({ url, title, className }: Props) {
  const shareLine = () => {
    window.open(
      `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(url)}`,
      '_blank',
    );
  };
  const shareFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      '_blank',
    );
  };
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('คัดลอก link แล้ว');
    } catch {
      toast.error('คัดลอกไม่สำเร็จ');
    }
  };

  return (
    <div className={`flex flex-row flex-wrap items-center gap-2 ${className ?? ''}`}>
      <button
        type="button"
        onClick={shareLine}
        aria-label={`แชร์ ${title} ไป LINE`}
        className="hover:brightness-110"
        style={{ ...baseBtn, background: '#06C755', color: '#fff' }}
      >
        <MessageCircle size={14} />
        LINE
      </button>
      <button
        type="button"
        onClick={shareFacebook}
        aria-label={`แชร์ ${title} ไป Facebook`}
        className="hover:brightness-125"
        style={{ ...baseBtn, background: 'rgba(66,103,178,0.15)', color: '#8B9DC3' }}
      >
        <Share2 size={14} />
        Facebook
      </button>
      <button
        type="button"
        onClick={copyLink}
        aria-label="คัดลอก link"
        className="hover:brightness-125"
        style={{
          ...baseBtn,
          background: 'transparent',
          color: '#05F2F2',
          border: '1px solid rgba(5,242,242,0.2)',
        }}
      >
        <Link size={14} />
        คัดลอก
      </button>
    </div>
  );
}
